<template>
  <div class="product-listing-page">
    <b-container>
      <h2 class="mb-4">Product Catalog</h2>
      <b-row>
        <b-col v-for="product in products" :key="product.id" md="4" class="mb-4">
          <b-card
            :title="product.name"
            :img-src="product.image"
            img-top
            class="h-100 product-card"
            @click="viewProduct(product)"
          >
            <b-card-text>
              <p class="product-description">{{ product.description }}</p>
              <p class="product-price font-weight-bold text-primary">
                ${{ product.price }}
              </p>
              <small class="text-muted">Stock: {{ product.stock }} units</small>
            </b-card-text>
            <b-button
              variant="info"
              @click.stop="viewProduct(product)"
              class="w-100"
            >
              <b-icon-eye></b-icon-eye> View Details
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { showEventToast } from '../utils/eventToast';

export default {
  name: 'ProductListingPage',
  inject: ['getGtmProductId'],
  data() {
    return {
      products: [
        {
          id: 1,
          name: 'Wireless Headphones',
          description: 'High-quality wireless headphones with noise cancellation',
          price: 199.99,
          stock: 15,
          category: 'Electronics',
          image: 'https://picsum.photos/300/200?random=1'
        },
        {
          id: 2,
          name: 'USB-C Cable',
          description: 'Fast charging USB-C cable compatible with all devices',
          price: 24.99,
          stock: 50,
          category: 'Accessories',
          image: 'https://picsum.photos/300/200?random=2'
        },
        {
          id: 3,
          name: 'Phone Case',
          description: 'Durable protective phone case with premium materials',
          price: 34.99,
          stock: 30,
          category: 'Accessories',
          image: 'https://picsum.photos/300/200?random=3'
        },
        {
          id: 4,
          name: 'Portable Charger',
          description: '10000mAh portable power bank for all your devices',
          price: 49.99,
          stock: 25,
          category: 'Electronics',
          image: 'https://picsum.photos/300/200?random=4'
        },
        {
          id: 5,
          name: 'Screen Protector',
          description: 'Tempered glass screen protector with easy installation',
          price: 14.99,
          stock: 100,
          category: 'Accessories',
          image: 'https://picsum.photos/300/200?random=5'
        },
        {
          id: 6,
          name: 'Bluetooth Speaker',
          description: 'Portable Bluetooth speaker with 360° sound',
          price: 89.99,
          stock: 12,
          category: 'Electronics',
          image: 'https://picsum.photos/300/200?random=6'
        }
      ]
    };
  },
  methods: {
    viewProduct(product) {
      const gtmProductId = this.getGtmProductId(product);
      // Track view_item_list event for GTM
      if (window.dataLayer) {
        const eventData = {
          event: 'view_item_list',
          ecommerce: {
            items: [
              {
                item_id: gtmProductId,
                item_name: product.name,
                price: product.price,
                item_category: product.category
              }
            ]
          }
        };
        window.dataLayer.push(eventData);
        
        // Show toast with expandable details
        showEventToast(this, 'view_item_list', eventData, '👁️', 'info', {
          product_name: product.name,
          product_id: gtmProductId,
          price: `$${product.price}`
        });
      }

      // Also track via vue-gtag
      this.$gtag.event('Product_View_Initiated', {
        product_id: gtmProductId,
        product_name: product.name,
        product_price: product.price
      });

      // Emit event for parent to handle navigation
      this.$emit('product-selected', product);
    }
  },
  mounted() {
    // Track PLP view
    if (window.dataLayer) {
      const eventData = {
        event: 'view_item_list',
        ecommerce: {
          items: this.products.map(p => ({
            item_id: this.getGtmProductId(p),
            item_name: p.name,
            price: p.price,
            item_category: p.category
          }))
        }
      };
      window.dataLayer.push(eventData);
      
      // Show toast for page load event with expandable details
      showEventToast(this, 'view_item_list', eventData, '👁️', 'info', {
        products_count: this.products.length,
        categories: [...new Set(this.products.map(p => p.category))].join(', ')
      });
    }

    this.$gtag.pageview({
      pageTitle: 'Product Listing Page',
      pagePath: '/gtm-demo/plp'
    });
  }
};
</script>

<style scoped>
.product-listing-page {
  padding: 20px 0;
}

.product-card {
  transition: all 0.3s ease;
  cursor: pointer;
}

.product-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-4px);
}

.product-description {
  height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-price {
  font-size: 1.5rem;
  margin: 10px 0;
}
</style>
